import { render, staticRenderFns } from "./ventasFilters.vue?vue&type=template&id=2eff6704"
import script from "./ventasFilters.vue?vue&type=script&lang=js"
export * from "./ventasFilters.vue?vue&type=script&lang=js"
import style0 from "./ventasFilters.vue?vue&type=style&index=0&id=2eff6704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports